const e = {
  extends: "LuckyForLife",
  logo: !0,
  style: {
    colorPrimary: "#c67328",
    extraBall: {
      bg: "#c67328"
    }
  }
};
export {
  e as default
};
